module.exports = __webpack_public_path__ + "static/media/GMT.c6251ddb.svg";